import { Entity, MicroMClient } from "@mcurros2/microm";
import { UsuariosPasswordDef } from "./UsuariosPasswordDef";

export const UsuariosPasswordHelpText = '* Cambiar contraseña de Usuario.';

export class UsuariosPassword extends Entity<UsuariosPasswordDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new UsuariosPasswordDef(), parentKeys);
        this.Form = import('./UsuariosPasswordForm').then((module) => module.UsuariosPasswordForm);
        this.Title = "Contraseña de Usuario";
        this.HelpText = UsuariosPasswordHelpText;
    }
}